import axios from 'axios'
import { API_HOST } from 'constants/apiHost'
import getDataHash from 'helpers/getDataHash'
import openExternalWindow from 'helpers/openExternalWindow'
import logger from 'helpers/logger'
import { createList } from 'components/Items/actions'
import {
    FETCH_SAVE_SHOPPING_LIST_REQUEST,
    FETCH_SAVE_SHOPPING_LIST_SUCCESS,
    FETCH_SAVE_SHOPPING_LIST_ERROR
} from '../constants/actionTypes'


// transforming data for BE
const getFormattedItems = (items) => {
    const formattedItems = []

    Object.keys(items).forEach(itemId => {
        formattedItems.push({
            description: items[itemId].name,
            note: items[itemId].note
        })
    })

    return formattedItems
}

export const fetchSaveShoppingList = () => (dispatch, getState) => {
    dispatch({
        type: FETCH_SAVE_SHOPPING_LIST_REQUEST
    })

    const nextState = getState()
    const userId = nextState.app.userId
    const listId = nextState.items.listId
    const listName = nextState.items.listName
    const transferSource = nextState.configuration.deliveryChannel
    const language = nextState.app.language

    const items = getFormattedItems(nextState.items.byId)

    const data = {
        userId,
        listId,
        listName,
        items,
        transferSource
    }

    // open new window tab now to avoid browser blocking
    const externalWindow = openExternalWindow()

    axios({
        method: 'post',
        url: `${API_HOST}/widgetlist`,
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
            'Signature-Hash': getDataHash(data)
        },
        data
    })
    .then(() => {
        const nextState = getState()
        const listId = nextState.items.listId
        const deliveryChannel = nextState.configuration.deliveryChannel
        externalWindow.location.href = `https://outofmilk.com/loginWidget?transferListId=${listId}&transferSource=${deliveryChannel}&transferMethod=LINKOUT&lang=${language}#signinanchor`

        dispatch({
            type: FETCH_SAVE_SHOPPING_LIST_SUCCESS
        })

        dispatch(createList())
    })
    .catch(error => {
        logger(error.response.data.errorMessage, 'error')

        dispatch({
            type: FETCH_SAVE_SHOPPING_LIST_ERROR
        })
    })
}
